import useYotpoInit from '@root/src/hooks/useYotpoInit';

/**
 * @todo Need to come back to use the return value of `useYotpoInit()`,
 * and fix any remaining problems with rendering in cases where loading
 * has been deferred by Cookiebot
 */
const YotpoReviewsBadge = () => {
  useYotpoInit();

  return <div id="y-badges" className="yotpo badge badge-init mt-32" suppressHydrationWarning></div>;
};

export default YotpoReviewsBadge;
